import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const baseUrl = "/api/esg/dsr";

export function getSchema(type) {
  return axiosClient.get(`${baseUrl}/schema/${type}`);
}

export function get(id) {
  return axiosClient.get(`${baseUrl}/${id}`);
}

export function getByEnterpriseIdAndYear(enterpriseId, year) {
  const query = getQuery({
    enterpriseId: enterpriseId,
    year: year,
  });
  return axiosClient.get(baseUrl, query);
}

// Elenco senza il blob `data`: serve a chi deve solo scegliere una dichiarazione.
// La risposta piena resta il default perche' il clone di un DSR duplica l'entita' intera.
export function getSummariesByEnterpriseId(enterpriseId) {
  const query = getQuery({ enterpriseId, summary: true });
  return axiosClient.get(baseUrl, query);
}

export function compare(ids, lang = "it") {
  return axiosClient.get(`${baseUrl}/compare?${comparisonQuery(ids, lang)}`);
}

export function exportComparison(ids, lang = "it", includeDetail = false) {
  const query = `${comparisonQuery(ids, lang)}&includeDetail=${includeDetail}`;
  return axiosClient.get(`${baseUrl}/compare/export?${query}`, {
    responseType: "blob",
  });
}

// Il confronto approfondito: un solo .docx, costruito sul template dell'impresa scelto per hash.
export function exportComparisonWord(ids, hash, isMicro = false, lang = "it") {
  const query = `${comparisonQuery(ids, lang)}&hash=${encodeURIComponent(
    hash
  )}&isMicro=${isMicro}`;
  return axiosClient.get(`${baseUrl}/compare/export-word?${query}`, {
    responseType: "blob",
  });
}

// `ids` va ripetuto una volta per valore (`ids=1&ids=2`): la serializzazione di default di axios
// produrrebbe `ids[]=…`, che il binding di ASP.NET non lega a un `int[]`.
function comparisonQuery(ids, lang) {
  const params = new URLSearchParams();
  ids.forEach((id) => params.append("ids", id));
  params.append("lang", lang);
  return params.toString();
}

export function create(dsrToSave) {
  return axiosClient.post(`${baseUrl}`, dsrToSave);
}

export function save(data) {
  return axiosClient.post(`${baseUrl}/save`, data);
}

export function remove(id) {
  return axiosClient.delete(`${baseUrl}/${id}`);
}

export function rename(id, name) {
  return axiosClient.post(`${baseUrl}/${id}/rename`, { id, name });
}

export function exportWord(
  dsrId,
  hash,
  isMicroEnterprise = false,
  lang = "it"
) {
  const query = getQuery({ hash, isMicro: isMicroEnterprise, lang });
  return axiosClient.get(`${baseUrl}/${dsrId}/export`, {
    responseType: "blob",
    ...query,
  });
}

export function getFacilities(dsrId) {
  return axiosClient.get(`${baseUrl}/${dsrId}/facilities`);
}

export function getTemplates(enterpriseId) {
  const query = getQuery({ enterpriseId });
  return axiosClient.get(`${baseUrl}/templates`, query);
}

export function uploadTemplate(enterpriseId, file) {
  const query = getQuery({ enterpriseId });
  const formData = new FormData();
  formData.append("template", file);

  return axiosClient.post(`${baseUrl}/templates`, formData, {
    ...query,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function deleteTemplate(id) {
  return axiosClient.delete(`${baseUrl}/templates/${id}`);
}

// Scarica il template DSR di esempio
export function downloadSampleTemplate() {
  return axiosClient.get(`${baseUrl}/templates/sample/download`, {
    responseType: "blob",
  });
}

export function getCoordinates(address) {
  return axiosClient.get(`${baseUrl}/geocoding`, {
    params: {
      address,
    },
  });
}

export function getEmissionFactorCoefficients() {
  return axiosClient.get(`${baseUrl}/emission-factors`);
}

export function addFacilities(dsrId, facilitiesDto) {
  return axiosClient.post(`${baseUrl}/${dsrId}/facilities`, facilitiesDto);
}

export function getEnterpriseExportLogs(enterpriseId) {
  return axiosClient.get(`${baseUrl}/enterprise/${enterpriseId}/export-logs`);
}
